import React from "react";
import { Link } from "react-router-dom";
import { FEEDBACK_FORM_URL } from "../utils/constants";
import "../App.css";

export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer-text">
        Disclaimer: This site is an AI-powered fan project for entertainment
        purposes only. We do not own or claim any rights to the characters
        entered or displayed. All character names and likenesses are property of
        their respective owners.
      </p>
      <div className="footer-links">
        <Link to="/rules" className="footer-feedback-link">Rules</Link>
        <a
          href={FEEDBACK_FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="footer-feedback-link"
        >
          Share Feedback
        </a>
      </div>
    </footer>
  );
}
